<template>
  <router-view v-slot="{ Component }">
    <keep-alive>
      <component v-if="$route.meta.keepAlive" :is="Component" />
    </keep-alive>
    <component v-if="!$route.meta.keepAlive" :is="Component" />
  </router-view>
  <!-- <router-view></router-view> -->
</template>

<script>
import { useTheme } from "./theme";
export default {
  setup() {
    const { initializeTheme } = useTheme();
    initializeTheme(); // 初始化主题
  },
  data() {
    return {
      // isDark: false, // 用于跟踪当前主题状态
    };
  },
  methods: {
    // toggleTheme() {
    //   this.isDark = !this.isDark;
    //   const newTheme = this.isDark ? "dark" : "light";
    //   document.documentElement.setAttribute("data-theme", newTheme);
    // },
    // initializeTheme() {
    //   const savedTheme =
    //     document.documentElement.getAttribute("data-theme") || "dark"; // 默认 dark
    //   this.isDark = savedTheme === "dark";
    //   document.documentElement.setAttribute("data-theme", savedTheme);
    // },
  },
  mounted() {
    // this.initializeTheme(); // 初始化主题
  },
};
</script>

<style lang="scss">
#app {
  font-family: "Noto Sans SC", "PingFang SC", "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
/* .header {
  width: 100vw;
  height: 5rem;
  background: var(--background-color2);
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 1.5rem;
  border-bottom: 1px solid var(--border-color2);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
  .header_left {
    display: flex;
    align-items: center;
    .left_item {
      display: flex;
      align-items: center;
      width: 9.5rem;
      height: 3.5rem;
      border-radius: 0.5rem;
      margin-right: 1rem;
      justify-content: center;
      img {
        width: 1.5rem;
        height: 1.5rem;
        margin-right: 1rem;
      }
    }
    .active {
      background: var(--background-color3);
    }
  }
  .header_right {
    img {
      cursor: pointer;
      width: 2rem;
      height: 2rem;
    }
  }
} */
.bgcolor {
  background-color: var(--xk-sky-deep);
  background-image: linear-gradient(90deg, var(--xk-sky-deep), var(--xk-sky));
  -webkit-box-shadow: 0 5px 10px 0 rgba(16, 110, 253, 0.3);
  box-shadow: 0 5px 10px 0 rgba(16, 110, 253, 0.25);
  color: #fff !important;
}
.mengban {
  width: 100%;
  height: 100%;
  background: rgba(8, 24, 40, 0.48);
  backdrop-filter: blur(2px);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2000;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  box-sizing: border-box;
  .loginbox {
    width: min(920px, calc(100vw - 32px));
    min-height: 460px;
    height: auto;
    background: #fff;
    display: flex;
    position: relative;
    border-radius: 16px;
    overflow: hidden;
    box-shadow: 0 20px 48px rgba(15, 40, 70, 0.22);
    .loginbox_left {
      width: 42%;
      display: flex;
      flex-direction: column;
      align-items: center;
      padding: 36px 32px;
      box-sizing: border-box;
      justify-content: center;
      gap: 12px;
      @media (max-width: 768px) {
        width: 100%;
        padding: 28px 20px;
      }
      .login_title {
        font-size: 1.75rem;
        line-height: 1.3;
        text-align: center;
        color: #17324a;
        width: 100%;
        @media (max-width: 768px) {
          font-size: 20px;
        }
        h3 {
          margin: 0;
          font-weight: 700;
        }
      }
      .title_minor {
        margin-bottom: 8px;
        em {
          display: inline-block;
          width: 36px;
          height: 0px;
          border-bottom: 1px solid rgba(221, 221, 221, 1);
          vertical-align: middle;
        }
        span {
          list-style: none;
          font-size: 12px;
          color: #888888;
          margin: 0 14px;
        }
      }
      .input_box {
        width: 100%;
        display: flex;
        align-items: center;
        height: 42px;
        border-radius: 8px;
        img {
          width: 20px;
          height: 20px;
        }
        input {
          border: none;
        }
      }
      .login_btn {
        width: 100%;
        margin-top: 8px;
        text-align: center;
        height: 42px;
        border-radius: 8px;
        font-size: 15px;
        line-height: 42px;
        cursor: pointer;
      }
      .tishi_btn {
        width: 100%;
        min-height: 40px;
        text-align: center;
        line-height: 1.4;
        padding: 10px 12px;
        box-sizing: border-box;
        background: #e8f4ff;
        color: #0b78c4;
        border-radius: 8px;
        margin-top: 4px;
        font-size: 13px;
        @media (max-width: 768px) {
          font-size: 13px;
        }
      }
      .bottom_box {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        font-size: 0.875rem;
        line-height: 1.5;
        color: #999;
        margin-top: 4px;
        @media (max-width: 768px) {
          font-size: 14px;
        }
        .box_left {
          cursor: pointer;
          color: #0b78c4;
        }
        .box_right {
          cursor: pointer;
        }
      }
    }
    .cha {
      width: 28px;
      height: 28px;
      position: absolute;
      right: 14px;
      top: 14px;
      cursor: pointer;
      z-index: 2;
      filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.15));
    }
    .loginbox_right {
      width: 58%;
      min-height: 100%;
      padding: 36px 32px;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      background:
        radial-gradient(ellipse 80% 60% at 90% 10%, rgba(255, 255, 255, 0.22), transparent 50%),
        linear-gradient(145deg, #0b78c4 0%, #1a9be8 55%, #3eb6f5 100%);
      @media (max-width: 768px) {
        display: none;
      }
    }
    .login-notice {
      width: 100%;
      background: rgba(255, 255, 255, 0.96);
      border-radius: 14px;
      padding: 24px 22px 20px;
      color: #17324a;
      box-shadow: 0 12px 28px rgba(8, 50, 90, 0.18);
    }
    .notice-badge {
      display: inline-block;
      padding: 4px 12px;
      border-radius: 6px;
      background: #e8f4ff;
      color: #0b78c4;
      font-size: 12px;
      font-weight: 600;
      margin-bottom: 16px;
    }
    .notice-block {
      margin-bottom: 14px;
      h4 {
        margin: 0 0 8px;
        font-size: 16px;
        font-weight: 700;
        color: #17324a;
        &.accent {
          color: #0b78c4;
        }
      }
      p {
        margin: 0;
        font-size: 13px;
        line-height: 1.7;
        color: #4a5d6f;
      }
    }
    .notice-tips {
      margin-top: 4px;
      padding-top: 12px;
      border-top: 1px dashed rgba(11, 120, 196, 0.25);
      p {
        margin: 0 0 6px;
        font-size: 12px;
        line-height: 1.5;
        color: #6a7d8f;
      }
    }
    .notice-qr {
      margin-top: 14px;
      display: flex;
      align-items: center;
      gap: 12px;
      img {
        width: 72px;
        height: 72px;
        object-fit: cover;
        border-radius: 8px;
        border: 1px solid #e5eef6;
        background: #fff;
      }
      span {
        font-size: 12px;
        color: #6a7d8f;
      }
    }
  }
  .registerbox {
    width: min(980px, calc(100vw - 32px));
    min-height: 520px;
    height: auto;
    align-items: stretch;

    .loginbox_left {
      width: 48%;
      gap: 10px;
      padding: 32px 28px;
      justify-content: center;
    }

    .loginbox_right {
      width: 52%;
      padding: 28px;
      align-items: stretch;
    }

    .login-notice {
      height: 100%;
      box-sizing: border-box;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    .register-fields {
      width: 100%;
      display: flex;
      flex-direction: column;
      gap: 10px;
    }

    .pwd-row {
      display: grid;
      grid-template-columns: 1fr 1fr;
      gap: 10px;

      @media (max-width: 900px) {
        grid-template-columns: 1fr;
      }
    }

    .xieyi {
      width: 100%;
      display: flex;
      align-items: center;
      color: #888888;
      font-size: 13px;
      margin-top: 2px;

      @media (max-width: 768px) {
        font-size: 13px;
      }

      .agreen_btn {
        margin-right: 10px;
      }

      a {
        color: #0b78c4;
        text-decoration: none;

        @media (max-width: 768px) {
          font-size: 13px;
        }
      }
    }

    .bottom_box {
      margin-top: 8px;
    }

    @media (max-width: 768px) {
      .loginbox_left {
        width: 100%;
      }
    }
  }
  .userinfobox {
    width: min(920px, calc(100vw - 32px));
    max-height: min(88vh, 860px);
    overflow: auto;
    background: #fff;
    padding: 0 0 24px;
    border-radius: 16px;
    position: relative;
    box-shadow: 0 20px 48px rgba(15, 40, 70, 0.22);

    .user-close {
      position: absolute;
      top: 14px;
      right: 14px;
      z-index: 2;
      width: 32px;
      height: 32px;
      border: none;
      border-radius: 50%;
      background: rgba(23, 50, 74, 0.08);
      color: #17324a;
      font-size: 22px;
      line-height: 1;
      cursor: pointer;
      display: flex;
      align-items: center;
      justify-content: center;
      transition: background 0.2s ease;

      &:hover {
        background: rgba(23, 50, 74, 0.14);
      }
    }

    .guanbi {
      width: 30px;
      height: 30px;
      position: absolute;
      top: 14px;
      right: 14px;
      cursor: pointer;
      z-index: 2;
    }

    .user-header {
      display: flex;
      align-items: center;
      gap: 14px;
      padding: 28px 28px 18px;
      background:
        radial-gradient(ellipse 70% 120% at 0% 0%, rgba(26, 155, 232, 0.16), transparent 55%),
        linear-gradient(180deg, #f3f9fd 0%, #ffffff 100%);
      border-bottom: 1px solid rgba(11, 120, 196, 0.1);

      h3 {
        margin: 0 0 4px;
        font-size: 1.25rem;
        color: #17324a;
        font-weight: 700;
      }

      p {
        margin: 0;
        font-size: 0.88rem;
        color: #6a7d8f;
      }
    }

    .user-avatar {
      width: 48px;
      height: 48px;
      border-radius: 14px;
      background: linear-gradient(145deg, #0b78c4, #1a9be8);
      color: #fff;
      font-size: 1.15rem;
      font-weight: 700;
      display: grid;
      place-items: center;
      flex-shrink: 0;
      box-shadow: 0 8px 18px rgba(11, 120, 196, 0.28);
    }

    .user-section-title {
      margin: 4px 0 12px;
      padding-left: 12px;
      font-size: 0.95rem;
      font-weight: 600;
      color: #17324a;
      position: relative;

      &::before {
        content: "";
        position: absolute;
        left: 0;
        top: 0.25em;
        bottom: 0.25em;
        width: 3px;
        border-radius: 2px;
        background: linear-gradient(180deg, #0b78c4, #1a9be8);
      }
    }

    .infobox {
      padding: 18px 24px 0;
    }

    .userinfo {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      padding: 0 24px;

      .userinfo_left {
        display: flex;
        align-items: center;

        img {
          margin-right: 20px;
          height: 80px;
          width: 80px;
          border-radius: 40px;
        }

        .userinfo_name {
          margin-bottom: 10px;
          font-weight: 600;
          color: #17324a;
        }

        .tishi1 {
          color: #6a7d8f;
          font-size: 0.875rem;
          line-height: 1.5;
        }
      }

      .userinfo_right {
        height: 40px;
        width: 100px;
        border-radius: 8px;
        text-align: center;
        line-height: 40px;
      }
    }

    .infobox_item {
      display: flex;
      gap: 14px;
      margin-bottom: 16px;

      @media (max-width: 720px) {
        flex-direction: column;
      }

      .input_box {
        width: 50%;
        box-sizing: border-box;
        padding: 0;

        @media (max-width: 720px) {
          width: 100%;
        }

        .input_name {
          color: #6a7d8f;
          line-height: 1.5;
          margin-bottom: 8px;
          font-size: 0.86rem;

          @media (max-width: 768px) {
            font-size: 14px;
          }
        }

        .el-input {
          --el-input-border-radius: 8px;
        }
      }
    }

    .tishi2 {
      line-height: 1.6;
      margin: 4px 0 18px;
      padding: 12px 14px;
      border-radius: 10px;
      background: #fff5f5;
      border: 1px solid rgba(255, 95, 122, 0.2);
      color: #d1435b;
      font-size: 0.86rem;

      strong {
        display: block;
        margin-bottom: 4px;
        font-size: 0.9rem;
      }

      p {
        margin: 0;
      }

      span {
        color: #8a6a72;
      }

      @media (max-width: 768px) {
        font-size: 13px;
      }
    }

    .user-actions {
      display: flex;
      justify-content: flex-end;
      padding-top: 8px;
    }

    .baocun {
      min-width: 120px;
      height: 42px;
      text-align: center;
      line-height: 42px;
      margin-left: 0;
      border-radius: 8px;
      cursor: pointer;
      font-size: 0.95rem;
      box-shadow: 0 8px 18px rgba(11, 120, 196, 0.22);

      @media (max-width: 768px) {
        font-size: 14px;
        width: 100%;
      }
    }
  }
  .qrcodebox {
    background: #ffffff80;
    padding: 30px;
    border-radius: 4px;
    position: relative;
    .cha {
      width: 30px;
      height: 30px;
      position: absolute;
      right: 4px;
      top: 4px;
      cursor: pointer;
    }
  }
}
footer.site-footer {
  background-color: transparent;
}

footer {
  background-color: #222;
  width: 100%;
  .ceo_grid {
    display: flex;
    padding: 1.875rem; /* 30px -> 1.875rem */
    width: 100%;
    box-sizing: border-box;
    .ceo_grid1 {
      width: 33%;
      img {
        width: 15rem;
      }
      p {
        color: #676b6f;
        font-size: 1rem;
        line-height: 1.5;
        margin-top: 0.625rem; /* 10px -> 0.625rem */
      }
    }
    .ceo_grid2 {
      width: 66%;
      display: flex;
      color: #676b6f;
      .ceo_width_1_3 {
        width: 33%;
        .foot_item_title {
          font-size: 1rem; /* 16px -> 1rem */
          margin-bottom: 0.625rem; /* 10px -> 0.625rem */
        }
        .ceo_padding_remove {
          li {
            font-size: 0.75rem; /* 12px -> 0.75rem */
            margin-bottom: 0.625rem; /* 10px -> 0.625rem */
            float: left;
            width: 50%;
          }
        }
      }
    }
    ul,
    li {
      list-style: none;
    }
    a {
      color: inherit;
      text-decoration: none;
    }
  }
  .foot_cop {
    width: 100%;
    box-sizing: border-box;
    background: #25282a;
    color: #676b6f;
    font-size: 0.8125rem; /* 13px -> 0.8125rem */
    padding: 0.9375rem; /* 15px -> 0.9375rem */
    display: flex;
    justify-content: space-between;
    align-items: center;
    a {
      color: #676b6f;
      text-decoration: none;
    }
    img {
      width: 1rem; /* 16px -> 1rem */
      height: 1.25rem; /* 20px -> 1.25rem */
      display: inline-block;
      transform: translateY(0.2rem); /* 20px -> 1.25rem */
      position: relative;
      margin-right: 0.1875rem; /* 3px -> 0.1875rem */
    }
  }
}
</style>
